import { downloadFileFromUrl } from "@/composables/useDownload";
import { axios_instance } from "@/api/api";
import { AxiosError as AxiosErrorClass } from "axios";

export interface ShellFile {
  name: string;
  size: number;
  last_modified: string;
  etag: string;
}

export interface FileListResponse {
  bucket: string;
  count: number;
  files: ShellFile[];
  next_marker: string;
}

// List files uploaded to the "shell" bucket (agent shell upload endpoint).
// Paginated via the server-side `marker` token.
export async function listShellFiles(
  marker = "",
): Promise<FileListResponse> {
  try {
    const res = await axios_instance.get<FileListResponse>(
      "/api/v1/view/cmd/list",
      { params: { marker } },
    );
    return res.data;
  } catch (err) {
    const message =
      err instanceof AxiosErrorClass && err.response?.data?.error
        ? String(err.response.data.error)
        : (err instanceof Error ? err.message : String(err));
    throw new Error(message);
  }
}

// Trigger a browser download of a file stored in the "shell" bucket.
// The server serves raw bytes with an attachment disposition, so the auth
// cookie (JWT) is included automatically by the browser.
export function downloadShellFile(name: string) {
  const url = `/api/v1/view/cmd/file/download?name=${encodeURIComponent(
    name,
  )}`;
  downloadFileFromUrl(url, name);
}
